export const USER_LOADING = 'USER_LOADING';
export const USER_ERROR = 'USER_ERROR';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_DELETED = 'USER_DELETED';
export const USER_DISABLED = 'USER_DISABLED';
export const USER_REACTIVATED = 'USER_REACTIVATED';
export const USER_SEARCH = 'USER_SEARCH';
export const USERS_STATS = 'USERS_STATS';
export const ACTUAL_USER_SUCCESS = 'ACTUAL_USER_SUCCESS';
